import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { RotateCcw } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const RetryStrip = ({ queue, onDone }) => {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      const { data: d } = await axios.post(`${API}/admin/jobs/retry-emails`);
      toast[d.sent ? "success" : "message"](`Retry pass done — ${d.sent} sent, ${d.still_failing} will try again, ${d.gave_up} gave up.`);
      onDone?.();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Retry pass failed to start.");
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="tacc-card p-4 md:p-5 flex flex-col sm:flex-row sm:items-center justify-between gap-3" data-testid="emails-retry-strip">
      <div>
        <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-[#78716C] flex items-center gap-2"><RotateCcw size={12} className="text-[#B45309]" /> Delivery retries</div>
        <p className="text-xs text-[#A8A29E] mt-1 max-w-xl">
          When the email provider is busy (429) or blips, member emails are queued and retried automatically every 15 minutes, up to 3 attempts. Only then does a row show as <span className="text-red-400">failed</span>.
          {" "}<span className="text-[#44403C]" data-testid="emails-retry-queue">{queue} in the queue right now.</span>
        </p>
      </div>
      <button onClick={run} disabled={busy || !queue} className="btn-outline text-xs whitespace-nowrap disabled:opacity-40" data-testid="emails-retry-btn">
        <RotateCcw size={13} className={busy ? "animate-spin" : ""} /> {busy ? "Retrying…" : "Retry queued now"}
      </button>
    </div>
  );
};
